// extracted by mini-css-extract-plugin
export default {"container":"FT6sHlj_voH4y8RGnmiu","headline":"G1k0_vJ1YXkpxsJ5ELBQ","price":"dftwamL82UI5aHz4m3FT","smallLink":"eRLORIVS1LMeLWJ66qBe"};